<script>
    // @ts-nocheck
    import { goto } from '$app/navigation';
	import { locale,_ } from 'svelte-i18n';
    import { page } from '$app/stores';
	import {setLang} from '../stores/langStore';

    const pathname = $page.url.pathname

    $: active_class = pathname == '/peta' ? 'me-2 fw-semibold' : 'nav-item'
    $: active_class_1 = pathname == '/peta' ? 'dropdown-toggle nav-link nav-link-header px-2 link-light text-uppercase' : 'nav-link dropdown-toggle'

    const changelanguage =  (lang) => {
        $setLang.default = lang;
        localStorage.setItem('lang',lang)
        locale.set(lang)

        if(pathname == '/indikasi-luas-kebakaran'){
            const thisPage = window.location.pathname;
            console.log('goto ' + thisPage);

            goto('/').then(
                () => goto(thisPage)
            );
        }
    }
</script>

<style>
    .title-white {
        color: white !important
    }

	#mainNav .navbar-nav .nav-item .nav-link {
		color: white;
	}
</style>

<li class="{active_class}" style="cursor: pointer;">
    <div class="dropdown">
        <div id="langID" class="{active_class_1}" data-bs-toggle="dropdown">
            <img src="{$setLang[$setLang.default].img}" alt="id" style="width: 1.2rem;margin-right: 4px;padding-bottom: 2px;">{$setLang[$setLang.default].text}
        </div>
        <ul class="dropdown-menu" style="min-width: 21px !important;left: -5px;">
            <!-- svelte-ignore a11y-invalid-attribute -->
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
            <li on:click={() => changelanguage('id')}><a class="dropdown-item" href="#"><img src="{$setLang['id'].img}" alt="id" style="width: 1.2rem;margin-right: 4px;padding-bottom: 2px;">{$setLang['id'].text}</a></li>
            <!-- svelte-ignore a11y-invalid-attribute -->
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
            <li on:click={() => changelanguage('en')}><a class="dropdown-item" href="#"><img src="{$setLang['en'].img}" alt="id" style="width: 1.2rem;margin-right: 4px;padding-bottom: 2px;">{$setLang['en'].text}</a></li>
        </ul>
</li>